<div class="dialog-content-container p-4">
    <ng-container [formGroup]="form">
        <div class="flex flex-column gap-4">
            <!-- Sales Support Person -->
            <div>
                <p-inputgroup>
                    <p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
                    <p-floatlabel variant="on" class="flex-1">
                        <p-select
                            inputId="salesSupportPerson"
                            formControlName="salesSupportPerson"
                            [options]="salesSupportPersons()"
                            optionLabel="name"
                            (onChange)="onSalesSupportPersonChange()"
                            styleClass="w-full"
                            [appendTo]="'body'" />
                        <label for="salesSupportPerson">{{ "REVIEW_ORDER.SELECT_LABEL" | translate }} *</label>
                    </p-floatlabel>
                </p-inputgroup>
            </div>

            <!-- Send Mail Toggle -->
            <div class="flex align-items-center gap-3">
                <p-toggleswitch
                    [ngModel]="sendMail()"
                    (ngModelChange)="onSendMailChange($event)"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="!form.controls.salesSupportPerson.value"
                    inputId="sendMail" />
                <label for="sendMail">{{ 'REVIEW_ORDER.SHOULD_SEND_MAIL' | translate }}</label>
            </div>

            <!-- Mail Form -->
            @if (sendMail()) {
                <!-- Recipient Email -->
                <div>
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
                        <p-floatlabel variant="on" class="flex-1">
                            <input id="recipientEmail" pInputText formControlName="recipientEmail" class="w-full" />
                            <label for="recipientEmail">{{ "QUOTE.DETAIL.QUOTE_INFORMATION.SEND_TO" | translate }} *</label>
                        </p-floatlabel>
                    </p-inputgroup>
                    <app-core-errors [control]="form.get('recipientEmail')"></app-core-errors>
                </div>

                <!-- CC Emails -->
                <div>
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-users"></i></p-inputgroup-addon>
                        <p-floatlabel variant="on" class="flex-1">
                            <input
                                id="ccEmail"
                                pInputText
                                [formControl]="ccEmailControl"
                                (keydown.enter)="addCcRecipient(); $event.preventDefault()"
                                (blur)="addCcRecipient()"
                                class="w-full"
                            />
                            <label for="ccEmail">{{ "QUOTE.DETAIL.QUOTE_INFORMATION.SEND_COPY_TO" | translate }}</label>
                        </p-floatlabel>
                    </p-inputgroup>
                    <app-core-errors [control]="ccEmailControl"></app-core-errors>
                    @if (validCcEmails.length > 0) {
                        <div class="flex flex-wrap gap-2 mt-2">
                            @for (email of validCcEmails; track email) {
                                <p-chip [label]="email" [removable]="true" (onRemove)="removeCcRecipient(email)" />
                            }
                        </div>
                    }
                </div>

                <!-- Message -->
                <div>
                    <p-inputgroup>
                        <p-inputgroup-addon><i class="pi pi-envelope"></i></p-inputgroup-addon>
                        <p-floatlabel variant="on" class="flex-1">
                            <textarea
                                id="message"
                                pTextarea
                                formControlName="message"
                                [rows]="4"
                                [autoResize]="true"
                                class="w-full"
                            ></textarea>
                            <label for="message">{{ "SEND_QUOTE.LBL_MESSAGE" | translate }}</label>
                        </p-floatlabel>
                    </p-inputgroup>
                </div>

                <!-- Add Comment Toggle -->
                <div class="flex align-items-center gap-3">
                    <p-toggleswitch
                        [ngModel]="showCommentField()"
                        (ngModelChange)="onShowCommentFieldChange($event)"
                        [ngModelOptions]="{ standalone: true }"
                        inputId="showCommentField" />
                    <label for="showCommentField">{{ "SEND_QUOTE.ADD_COMMENT" | translate }}</label>
                </div>

                <!-- Comment -->
                @if (showCommentField()) {
                    <div>
                        <p-inputgroup>
                            <p-inputgroup-addon><i class="pi pi-comment"></i></p-inputgroup-addon>
                            <p-floatlabel variant="on" class="flex-1">
                                <textarea
                                    id="comment"
                                    pTextarea
                                    formControlName="comment"
                                    [rows]="4"
                                    [autoResize]="true"
                                    class="w-full"
                                ></textarea>
                                <label for="comment">{{ "SEND_QUOTE.LBL_COMMENT" | translate }}</label>
                            </p-floatlabel>
                        </p-inputgroup>
                    </div>
                }
            }
        </div>

        <!-- Actions -->
        <div class="flex justify-content-end gap-2 mt-5">
            <p-button
                [label]="'ABORT' | translate"
                [text]="true"
                (onClick)="onCancel()" />
            <p-button
                [label]="'REVIEW_ORDER.CONFIRM_BTN' | translate"
                [disabled]="form.invalid"
                (onClick)="onConfirm()" />
        </div>
    </ng-container>
</div>
